import React from "react";
import { LoginWithGoogleButton } from "../../../../global/auth/loginProviderButtons/LoginWithGoogleButton";
import { LoginWithAppleButton } from "../../../../global/auth/loginProviderButtons/LoginWithAppleButton";
import { ListingModalLoginOpenSignupModalBtn } from "./ListingModalLoginOpenSignupModalBtn";
import { LoginServiceProvider } from "../../../../global/auth/loginProviderButtons";
import { ListingModalLoginWrapper } from "./ListingModalLoginWrapper";
import { ListingModalLoginHeader } from "./ListingModalLoginHeader";
import { ListingModalLoginTitle } from "./ListingModalLoginTitle";
import { ListingModalLoginSubtitle } from "./ListingModalLoginSubtitle";
import { ListingModalLoginContent } from "./ListingModalLoginContent";
import { ListingModalLoginContentButtons } from "./ListingModalLoginContentButtons";
import { ListingModalLoginSeparator } from "./ListingModalLoginSeparator";

export const ListingModalLogIn = () => {
  return (
    <ListingModalLoginWrapper>
      <ListingModalLoginHeader>
        <ListingModalLoginTitle>Join Pod1um for free</ListingModalLoginTitle>

        <ListingModalLoginSubtitle>
          Get started with free workouts from the worlds top coaches
        </ListingModalLoginSubtitle>
      </ListingModalLoginHeader>

      <ListingModalLoginContent>
        <ListingModalLoginContentButtons>
          <LoginServiceProvider>
            <LoginWithGoogleButton toReload={true} />
            <LoginWithAppleButton toReload={true} />
          </LoginServiceProvider>
        </ListingModalLoginContentButtons>

        <ListingModalLoginSeparator />
        <ListingModalLoginOpenSignupModalBtn />
      </ListingModalLoginContent>
    </ListingModalLoginWrapper>
  );
};
